// Per-page renderer for "suppliers" — extracted from reportBuilder.js.
// Signature: async (api, doc, ctx) => { y, aiInsights, aiRecommendations }
import autoTable from 'jspdf-autotable';
import { NAVY, formatValue } from '../utils';

export async function renderSuppliers(api, doc, ctx) {
  const { qs, filterDesc, cs, pw, page } = ctx;
  let y = ctx.y;
  let aiInsights = [];
  let aiRecommendations = [];

  const res = await api.get(`/suppliers?${qs}`);
  const suppliers = res.data || [];

  if (suppliers.length > 0) {
    autoTable(doc, {
      startY: y,
      head: [['Supplier', 'Category', 'Spend', 'Transactions', 'Contract']],
      body: suppliers.slice(0, 25).map(s => [
        s.name, s.category || 'N/A',
        formatValue(s.total_spend || 0),
        String(s.transaction_count || 0),
        s.contract_status || '-',
      ]),
      styles: { fontSize: 7 },
      headStyles: { fillColor: NAVY },
      margin: { left: 14, right: 14 },
    });
    y = doc.lastAutoTable.finalY + 8;
  }

  return { y, aiInsights, aiRecommendations };
}
